import React from "react";
import styled from "styled-components";
import { ListItemText, ListItem } from "@material-ui/core";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import URI from "urijs";
import Theme from "../../Theme";
import IContentsItem from "../../models/IContentsItem";

const HeaderListItem = styled(ListItem)<{ level: number }>`
  padding-left: ${props => (props.level - 1) * 20}px;
  word-break: break-all;
  cursor: default;
  color: ${Theme.colors.blackText};
  font-size: 16px;
  &&& a {
    color: ${Theme.colors.blackText};
    font-weight: 500;
    text-decoration: none;
  }
`;

const PlainLink = styled(Link)`
  text-decoration: none;
`;

const SubListItem = styled(ListItem)<{ level: number }>`
  padding-left: ${props => (props.level - 1) * 20}px;
  word-break: break-all;
  cursor: pointer;
`;

const StyledListItemText = styled(ListItemText)`
  font-size: 16px;
  color: ${Theme.colors.blackText};
`;

export interface IContentListItemProps extends IContentsItem {
  onClick?: (isExpander: boolean) => void;
}

const ContentListItem = (props: IContentListItemProps) => {
  const { href, isSelected, level, name, isOpen } = props;

  const handleClick = (isExpander: boolean) => () => {
    if (props.onClick) {
      props.onClick(isExpander);
    }
  };

  let isHash = false;
  try {
    isHash = !!URI(href).hash();
  } catch {
    /* do nothing */
  }

  if (!props.leaf) {
    return (
      <HeaderListItem button selected={isSelected} onClick={handleClick(false)} level={level}>
        <StyledListItemText>
          {isHash && href && (
            <HashLink smooth to={href}>
              {props.name}
            </HashLink>
          )}
          {!isHash && href && <Link to={href}>{name}</Link>}
          {!href && <StyledListItemText>{name}</StyledListItemText>}
        </StyledListItemText>
        {isOpen ? <ExpandLess titleAccess="Collapse Menu" onClick={handleClick(true)} /> : <ExpandMore titleAccess="Expand Menu" onClick={handleClick(true)} />}
      </HeaderListItem>
    );
  } else if (href) {
    return (
      <PlainLink to={href}>
        <SubListItem button selected={isSelected} onClick={handleClick(false)} level={level}>
          <StyledListItemText>{props.name}</StyledListItemText>
        </SubListItem>
      </PlainLink>
    );
  } else {
    return null;
  }
};

export default ContentListItem;
